/**
 * Generic type guards for use across core and app.
 * Domain-specific guards (e.g. isHospitalSearch) live in their domain modules (e.g. core/model/auctions).
 */

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isObject<T>(value: T): value is T & object {
  return value != null && typeof value === "object" && !Array.isArray(value);
}
